<template>
  <div class="col-12">
    <div class="col-12 text-subtitle2 text-bold">
      ESTADO CONSECUCIÓN DE OBJETIVO
    </div>
    <q-linear-progress
      rounded
      size="15px"
      :value="count"
      color="secondary"
      class="q-mt-sm q-mb-lg"
    >
      <q-tooltip anchor="center middle" self="center middle">
        {{ count * 100 }} %
      </q-tooltip>
    </q-linear-progress>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    count: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
